import { isIOS } from './isIOS';
import { isAndroid } from './isAndroid';
import isTablet from './isTablet';

function isMobileOrTablet() {
  return isAndroid() || isIOS() || isTablet();
}

export default isMobileOrTablet;
